import { render } from "./forgetpassword.vue?vue&type=template&id=70521f66"
import script from "./forgetpassword.vue?vue&type=script&lang=js"
export * from "./forgetpassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__